import { RepFieldAudit } from "@repo/models";
import { EditableGridPage, Loading } from "@repo/ui";
import { useCallback } from "react";

import { useRepFieldAuditQueries } from "../../api/repFieldAuditApi";
import { RepFieldAuditProvider, useRepContext, useRepFieldAuditContext } from "../../contexts/editableItemContext";
import { usePermissionsCheck } from "../../helpers/permissions";
import { useEntityId, useUpdateRoute } from "../../helpers/urlHooks";
import FieldAuditEditor from "./editor";
import FieldAuditGridBasic from "./grid";

function FieldAudits() {
	return (
		<RepFieldAuditProvider>
			<FieldAuditsInternal />
		</RepFieldAuditProvider>
	);
}

function FieldAuditsInternal() {
	const { repId, rep, repLoaded } = useRepContext();
	const { overwriteItem, pendingChanges } = useRepFieldAuditContext();

	const { useRepFieldAuditQuery } = useRepFieldAuditQueries();
	const { data, loaded } = useRepFieldAuditQuery();
	const entityId = useEntityId();
	const updateRoute = useUpdateRoute();

	const { fullAPReadOnly } = usePermissionsCheck();

	const handleOpen = (item: RepFieldAudit) => {
		overwriteItem(item);
	};

	const newItem = useCallback(() => {
		overwriteItem({
			createdOn: new Date(),
		} as RepFieldAudit);
	}, [overwriteItem, repId, rep]);

	return (
		<Loading loading={!loaded || !repLoaded}>
			<EditableGridPage<RepFieldAudit>
				pendingChanges={pendingChanges}
				items={data}
				keyProperty="representativeFieldAuditId"
				id="RepFieldAuditsContainer"
				openItem={handleOpen}
				newItem={newItem}
				Editor={FieldAuditEditor}
				Grid={FieldAuditGridBasic}
				itemsLoaded={loaded}
				entityId={entityId}
				updateRoute={updateRoute}
				fullReadOnly={fullAPReadOnly}
			/>
		</Loading>
	);
}

export default FieldAudits;
